import { render, staticRenderFns } from "./FileConfigurator.vue?vue&type=template&id=addffb6c&"
import script from "./FileConfigurator.vue?vue&type=script&lang=js&"
export * from "./FileConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports